import { Types as ATypes } from '../actions/agreementsActions';
import { Types as PTypes } from '../actions/publicAgreementActions';
import { Types as ITypes } from '../actions/indexationActions';

/**
 * Combined reducer for `AGREEMENTS_*`, `PUBLIC_AGREEMENT_*`, and `INDEXATION_*` (single dispatch prefix block in root reducer).
 */
const agreementsAppReducers = (state, action) => {
  if (action.type && action.type.indexOf('AGREEMENTS_') === 0) {
    return agreementsSlice(state, action);
  }
  if (action.type && action.type.indexOf('PUBLIC_AGREEMENT_') === 0) {
    return publicAgreementSlice(state, action);
  }
  if (action.type && action.type.indexOf('INDEXATION_') === 0) {
    return indexationSlice(state, action);
  }
  return state;
};

const agreementsSlice = (state, action) => {
  const base = { ...state };
  base.agreements = { ...(state.agreements || defaultAgreements) };

  switch (action.type) {
    case ATypes.SET: {
      const p = action.payload || {};
      base.agreements = {
        ...base.agreements,
        list: p.agreements || [],
        cancelEligibility: p.cancelEligibility,
        lastMeta: p._raw,
        listOrganisationId:
          p.listOrganisationId !== undefined
            ? p.listOrganisationId
            : base.agreements.listOrganisationId,
      };
      return base;
    }
    case ATypes.LOADING: {
      base.agreements = {
        ...base.agreements,
        loading: { ...base.agreements.loading, [action.key]: action.value },
      };
      return base;
    }
    case ATypes.ERROR: {
      base.agreements = { ...base.agreements, error: action.error };
      return base;
    }
    case ATypes.CREATE_RESULT: {
      base.agreements = { ...base.agreements, lastCreate: action.payload };
      return base;
    }
    case ATypes.RESEND_RESULT: {
      base.agreements = { ...base.agreements, lastResend: action.payload };
      return base;
    }
    case ATypes.VOID_RESULT: {
      base.agreements = { ...base.agreements, lastVoidId: action.payload?.id };
      return base;
    }
    case ATypes.SIGNED_PDF: {
      base.agreements = {
        ...base.agreements,
        signedPdfById: { ...base.agreements.signedPdfById, [action.payload.id]: action.payload.url },
      };
      return base;
    }
    case ATypes.PRODUCTS: {
      const { currency, products, flowDisabled } = action.payload || {};
      const key = currency || '_all';
      const prev = base.agreements.products || { byCurrency: {}, flowDisabled: false };
      base.agreements = {
        ...base.agreements,
        products: {
          ...prev,
          byCurrency: { ...prev.byCurrency, [key]: products || [] },
          flowDisabled: !!flowDisabled,
        },
      };
      return base;
    }
    case ATypes.CLEAR: {
      base.agreements = { ...defaultAgreements };
      return base;
    }
    default:
      return state;
  }
};

const defaultAgreements = {
  list: [],
  listOrganisationId: null,
  cancelEligibility: undefined,
  lastMeta: null,
  lastCreate: null,
  lastResend: null,
  lastVoidId: null,
  signedPdfById: {},
  products: { byCurrency: {}, flowDisabled: false },
  loading: {},
  error: null,
};

const publicAgreementSlice = (state, action) => {
  const base = { ...state };
  base.publicAgreement = { ...(state.publicAgreement || defaultPublic) };

  switch (action.type) {
    case PTypes.PAYLOAD: {
      base.publicAgreement = { ...base.publicAgreement, payload: action.value };
      return base;
    }
    case PTypes.LOADING: {
      base.publicAgreement = { ...base.publicAgreement, loading: action.value };
      return base;
    }
    case PTypes.ERROR: {
      base.publicAgreement = { ...base.publicAgreement, error: action.value };
      return base;
    }
    case PTypes.ACCEPT: {
      base.publicAgreement = { ...base.publicAgreement, acceptResult: action.value };
      return base;
    }
    case PTypes.CLEAR: {
      base.publicAgreement = { ...defaultPublic };
      return base;
    }
    default:
      return state;
  }
};

const defaultPublic = {
  payload: null,
  loading: false,
  error: null,
  acceptResult: null,
};

const defaultIndex = {
  rates: null,
  eventsByContractId: {},
  loading: {},
  error: null,
};

const indexationSlice = (state, action) => {
  const base = { ...state };
  base.indexation = { ...(state.indexation || defaultIndex) };

  switch (action.type) {
    case ITypes.RATES: {
      base.indexation = { ...base.indexation, rates: action.payload };
      return base;
    }
    case ITypes.EVENTS: {
      const { contractId, data } = action.payload || {};
      const events = data?.events;
      const next = { ...base.indexation.eventsByContractId };
      if (contractId) next[contractId] = data;
      base.indexation = { ...base.indexation, eventsByContractId: next, lastEvents: events };
      return base;
    }
    case ITypes.LOADING: {
      base.indexation = {
        ...base.indexation,
        loading: { ...base.indexation.loading, [action.key]: action.value },
      };
      return base;
    }
    case ITypes.ERROR: {
      base.indexation = { ...base.indexation, error: action.value };
      return base;
    }
    case ITypes.CLEAR: {
      base.indexation = { ...defaultIndex };
      return base;
    }
    default:
      return state;
  }
};

export default agreementsAppReducers;
export { defaultAgreements, defaultPublic, defaultIndex };
